export const EventTemplates = {
    EVENT_REMINDER: 'event_reminder'
};

export const ModuleTemplates = {
    MODULE_REMINDER: 'module_reminder'
};
